import {Location} from 'src/common/map/Location';
import {Game} from '../Game';
import Connection from 'src/Connection';
import {wallRenderer} from 'src/Pixi/map/WallRenderer';
import {SelectSpawnAction} from 'src/Action';
import {heldRenderer} from 'src/Pixi/map/HeldRenderer';
import {spawnRenderer} from 'src/Pixi/map/SpawnRenderer';

export class SelectSpawn {
    public constructor(public game: Game) {
        // Sets instance variables
    }

    public byServer({owner, index}: SelectSpawnAction): void {
        const walls = this.game.map.spawns[index].walls;
        walls.forEach(loc => {
            this.game.map.walls[loc.y][loc.x] = {owner, damaged: false};
        });
        wallRenderer.setMap(this.game.map);
        wallRenderer.buildWallPiece(walls.map(loc => new Location(loc.x, loc.y)));
        heldRenderer.setMap(this.game.map);
        heldRenderer.redraw();
        this.game.map.updateHeld();
        spawnRenderer.redraw(this.game.map);
        heldRenderer.redraw();
    }

    public byClient(spawnIndex: number): void {
        Connection.send('select', {spawnIndex});
    }
}



// WEBPACK FOOTER //
// ./src/game/actions/SelectSpawn.ts